import { useMemo } from 'react';

//* HOC's
import { withDataContext } from 'context';

//* Components
import Page from 'components/common/Page';
import Info from 'components/common/Info';
import Paths from 'components/common/Paths';
import Content from 'components/common/Content';
import Feedback from 'components/common/Feedback';
import Container from 'components/common/Container';
import BackButton from 'components/common/BackButton';
import RelatedBlogPosts from 'components/common/RelatedBlogPosts';

//* Style
import DestinationIndividualStyle from 'styles/pages/DestinationIndividualStyle';

const Destination = ({ singleDestination, pageParams, selectedLang, prevRoute }) => {
	//! Page Data
	const pageData = useMemo(() => singleDestination?.[pageParams.selectedSlug]?.[selectedLang], [singleDestination, pageParams, selectedLang]);

	return (
		<Page
			meta={pageData?.destination.meta}
			transparentHeader={pageParams.transparentHeader && !pageData}
		>
			{pageData && (
				<DestinationIndividualStyle>
					<div className='page-top'>
						<Paths
							paths={pageData.destination.paths}
							pathColor={'primaryColor1'}
						/>
						<BackButton
							prevRoute={prevRoute}
							backRoute={'/'}
							text={'back'}
						/>
					</div>

					<Container
						section
						className='main-content-wrap'
					>
						<Info
							isSticky={true}
							data={pageData.destination}
						/>
						<Content
							image={pageData.destination.banner_image}
							text={pageData.destination.description}
						/>
					</Container>

					{pageData && (
						<Container section>
							<Feedback
								type={pageData.destination.feedbackType}
								typeId={pageData.destination.id}
							/>
						</Container>
					)}

					{pageData?.relatedDestinations?.length > 0 && (
						<RelatedBlogPosts
							relatedTitle={'exploreMore'}
							articles={pageData.relatedDestinations}
						/>
					)}
				</DestinationIndividualStyle>
			)}
		</Page>
	);
};

export default withDataContext(Destination, ['singleDestination', 'prevRoute']);
